import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertCircleIcon, Loader2Icon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
export function AdminLogin() {
  const {
    loggedIn,
    login,
    verifyPassword
  } = useAdminData();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  if (loggedIn) return <Navigate to="/admin" replace data-id="element-217" data-mp="ed7a3herk4v6" />;
  return <div className="flex min-h-screen w-full items-center bg-canvas px-5 py-12" data-id="element-218" data-mp="egcx8r3u0wo9">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto w-full max-w-sm" data-id="element-219" data-mp="1uqnoz2snwq06">
        <img src={company.logoWide} alt="LYKKEVÆRK" className="h-14 w-auto" data-id="element-220" data-mp="1wpyframm0ew4" />
        <h1 className="mt-4 font-display text-xl font-semibold tracking-tight text-ink-soft" data-id="element-221" data-mp="20nw2m6swqowc">Admin</h1>

        <form className="mt-8 rounded-card border border-line bg-white p-6 md:p-8" onSubmit={async event => {
        event.preventDefault();
        if (loading) return;
        setLoading(true);
        const ok = await verifyPassword(password);
        if (!ok) {
          setError('Forkerte loginoplysninger. Prøv igen.');
          setPassword('');
          setLoading(false);
          return;
        }
        setError('');
        login();
        navigate('/admin');
      }} data-id="element-222" data-mp="25pd15vnx5z9r">
          <TextField id="admin-mail" label="E-mail" type="email" required autoComplete="off" value={email} onChange={event => {
          setEmail(event.target.value);
          if (error) setError('');
        }} data-id="element-223" data-mp="ua6gahk0e8os" />
          <TextField id="admin-kode" label="Password" type="password" required autoComplete="current-password" className="mt-5" value={password} onChange={event => {
          setPassword(event.target.value);
          if (error) setError('');
        }} data-id="element-224" data-mp="n5owu0qsgyt0" />

          {error && <p role="alert" className="mt-4 flex items-start gap-2 rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger" data-id="element-225" data-mp="48x5d413fddv">
              <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-226" data-mp="d7hg9j0ewirj" />
              {error}
            </p>}

          <Button type="submit" size="lg" className="mt-7 w-full" disabled={loading} data-id="element-227" data-mp="1tkpjtgxu66ng">
            {loading ? <>
                <Loader2Icon className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-228" data-mp="36ksqtzlf7djt" />
                Logger ind …
              </> : 'Log ind'}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-ink-muted" data-id="element-229" data-mp="2xke6b2ga62hd">
          <Link to="/" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-230" data-mp="2xm7dciut2opw">
            Tilbage til hjemmesiden
          </Link>
        </p>
      </motion.div>
    </div>;
}